import { render, staticRenderFns } from "./fmPerson.vue?vue&type=template&id=d5b716cc&scoped=true"
import script from "./fmPerson.vue?vue&type=script&lang=js"
export * from "./fmPerson.vue?vue&type=script&lang=js"
import style0 from "./fmPerson.vue?vue&type=style&index=0&id=d5b716cc&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b716cc",
  null
  
)

export default component.exports